'use client';

import { useSyncExternalStore } from 'react';

export const safeCheckDevSwitchIsOn = () => {
	try {
		return window?.localStorage?.getItem('devswitch') === 'true';
	} catch {
		return false;
	}
};

// Module-scope singleton: one 5s localStorage poll for the whole app session,
// regardless of how many components read the value. Replaces the previous
// react-singleton-hook wrapper (which mounted the poll in a detached React root)
// with a plain external store, so every consumer shares the same interval.
let devSwitchIsOn = false;
let started = false;
const listeners = new Set<() => void>();

const startPolling = () => {
	if (started || typeof window === 'undefined') return;
	started = true;
	devSwitchIsOn = safeCheckDevSwitchIsOn();
	setInterval(() => {
		const next = safeCheckDevSwitchIsOn();
		if (next !== devSwitchIsOn) {
			devSwitchIsOn = next;
			listeners.forEach((l) => l());
		}
	}, 5000);
};

const subscribe = (listener: () => void) => {
	startPolling();
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
};

const useDevSwitchIsOn = () =>
	useSyncExternalStore(
		subscribe,
		() => devSwitchIsOn,
		() => false
	);

export default useDevSwitchIsOn;
